import {
    Swiper,
    Navigation,
    // Autoplay,
    // Scrollbar,
} from 'swiper';

Swiper.use(Navigation);
// Swiper.use(Autoplay);
// Swiper.use(Scrollbar);

const navigation = (el) => {
    const swiperClass = {
        nextEl: '.' + el + '-swiper__button--next',
        prevEl: '.' + el + '-swiper__button--prev',
    }
    return swiperClass;
}

let swiper;

$(document).ready( function () {
    if($('.categories__swiper').length) {
        swiper = new Swiper('.categories__swiper', {
            loop: false,
            spaceBetween: 15,
            breakpoints: {
                992: {
                    slidesPerView: 6,
                },
                0: {
                    slidesPerView: 2.5,
                },
            },
            navigation: navigation('categories'),
        });
    }
    if($('.info-tiles__swiper').length) {
        $( '.module--info-tiles' ).each(function( index ) {
            var id = 'module--info-tiles--'+index;
            $(this).attr('id', id);
            swiper = new Swiper('#'+id+' .info-tiles__swiper', {
                loop: false,
                spaceBetween: 16,
                breakpoints: {
                    1200: {
                        slidesPerView: 4.2,
                    },
                    992: {
                        slidesPerView: 3.2,
                    },
                    0: {
                        slidesPerView: 1.2,
                    },
                },
                navigation: {
                    nextEl: '#'+id+' .info-tiles-swiper__button--next',
                    prevEl: '#'+id+' .info-tiles-swiper__button--prev',
                },
            });
        });
    }
    if($('.recent-blog__swiper').length) {
        swiper = new Swiper('.recent-blog__swiper:not(.recent-blog__swiper--speaker)', {
            loop: false,
            spaceBetween: 16,
            breakpoints: {
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                },
            },
            navigation: navigation('recent-blog'),
        });
        swiper = new Swiper('.recent-blog__swiper.recent-blog__swiper--speaker', {
            loop: false,
            spaceBetween: 16,
            breakpoints: {
                1400: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                0: {
                    spaceBetween: 16,
                    slidesPerView: 1.2,
                },
            },
            navigation: navigation('recent-blog'),
        });
    }

    if($('.recent-sermon__swiper').length) {
        swiper = new Swiper('.recent-sermon__swiper', {
            loop: false,
            autoHeight: true,
            spaceBetween: 30,
            breakpoints: {
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
            },
            navigation: navigation('recent-sermon'),
        });
    }

    if($('.recent-serie__swiper').length) {
        swiper = new Swiper('.recent-serie__swiper', {
            loop: false,
            spaceBetween: 30,
            breakpoints: {
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
            },
            navigation: navigation('recent-serie'),
        });
    }

    if($('.recent-event__swiper').length) {
        swiper = new Swiper('.recent-event__swiper', {
            loop: false,
            spaceBetween: 30,
            breakpoints: {
                1350: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 16,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
            },
            navigation: navigation('recent-event'),
        });
    }

    if($('.history__swiper').length) {
        swiper = new Swiper('.history__swiper', {
            loop: false,
            spaceBetween: 30,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1,
                },
            },
            navigation: navigation('history-swiper'),
        });
    }

    if($('.single-event__swiper').length) {
        swiper = new Swiper('.single-event__swiper', {
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: navigation('event'),
        });
    }

    if($('.speakers__swiper').length) {
        swiper = new Swiper('.speakers__swiper', {
            loop: false,
            spaceBetween: 30,
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                992: {
                    spaceBetween: 15,
                },
                767: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
            },
            navigation: navigation('speakers-nav'),
        });
    }
    if($('.album-swiper').length) {
        swiper = new Swiper('.album-swiper', {
            loop: false,
            spaceBetween: 16,
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                },
                992: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.2,
                },
            },
            navigation: navigation('album-swiper__pagination'),
        });
    }
    if($('.module--slider__wrapper__items').length) {
        swiper = new Swiper('.module--slider__wrapper__items', {
            loop: false,
            spaceBetween: 16,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                0: {
                    slidesPerView: 1.2,
                },
            },
            navigation: navigation('module--slider__wrapper__items__nav'),
        });
    }
});

$(window).on('resize', function () {
    if (swiper) {
        swiper.update();
    }
});
